// ** Redux, Thunk & Root Reducer Imports
import thunk from 'redux-thunk'
import { persistStore } from 'redux-persist'
import createDebounce from 'redux-debounced'
import persistedReducer from './persistRedurcers'
import rootReducer from '../reducers/rootReducer'
import { createStore, applyMiddleware, compose } from 'redux'

// ** init middleware
const middleware = [thunk, createDebounce()]

// ** Dev Tools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

// ** Create store
const store = createStore(persistedReducer(rootReducer), {}, composeEnhancers(applyMiddleware(...middleware)))
const persistor = persistStore(store)

export { store, persistor }
